module.exports = __webpack_public_path__ + "assets/img/code.fb04203b.png";